/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsacuityAcuityIntegration from './IntegrationsacuityAcuityIntegration';

/**
 * The IntegrationsMdiBody model module.
 * @module model/IntegrationsMdiBody
 * @version v0.3
 */
export default class IntegrationsMdiBody {
  /**
   * Constructs a new <code>IntegrationsMdiBody</code>.
   * @alias module:model/IntegrationsMdiBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsMdiBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsMdiBody} obj Optional instance to populate.
   * @return {module:model/IntegrationsMdiBody} The populated <code>IntegrationsMdiBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsMdiBody();
      if (data.hasOwnProperty('mdi_integration'))
        obj.mdiIntegration = IntegrationsacuityAcuityIntegration.constructFromObject(data['mdi_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsacuityAcuityIntegration} mdiIntegration
 */
IntegrationsMdiBody.prototype.mdiIntegration = undefined;

